// extracted by mini-css-extract-plugin
module.exports = {"rate-card-table-content":"_3zjFpp","rate-table-data":"_3VID62","ratemap-header":"mWlKCo","highlight-text":"_2FlWed"};